import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

/**
 * 履职清单批次记录的接口服务
 */
export class DutyListBatchServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 批次记录分页列表
  public getBatchRecordPageList(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListBatch';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 批次记录全部列表
  public getBatchRecordAllList(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListBatch/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增批次记录
  public addBatchRecord(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleListBatch';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 编辑批次记录
  public editBatchRecord(id: any, opts: object) {
    const url = serverUrl + `/api/yunnan/dutyRuleListBatch/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 获取批次记录
  public getBatchRecordDetails(id: any) {
    const url = serverUrl + `/api/yunnan/dutyRuleListBatch/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 删除批次记录
  public deleteBatchRecordList(idList: any) {
    if (idList instanceof Array) {
      idList = idList.join(',');
    }
    const url = serverUrl + '/api/yunnan/dutyRuleListBatch?idList=' + idList;
    return this.rSerivce.serverObj.delete(url, {
      params: idList,
    });
  }

  // 获取选择公司的列表
  public getCompanyPrincipalList(opts: object) {
    const url = serverUrl + '/api/yunnan/company/principal/list';
    return this.rSerivce.serverObj.post(url, opts);
  }
}
